import { apiRequests } from "../services/api";
import { GET_SKILL_GROUP , GET_GROUPS , GET_ID_GROUPS , GET_SKILLS , GET_CITY, GET_ACTIVITY } from "../graphql/query/groupSkills/query"
import { CREATE_GROUP , UPDATE_GROUP } from "../graphql/mutations/group/mutations"
import { CREATE_SKILLS , UPDATE_SKILLS , DELETE_SKILLS } from "../graphql/mutations/skills/mutations";

// query
export const  getGroupSkill = async() => {
    try{
        const response = await apiRequests(GET_SKILL_GROUP);
        //console.log('123',response);
        return response;
    }catch( $er ){
        console.warn('Las siguientes fallas son: ' , $er);
        return null;
    }
}

export const getGroups = async() => {
    try {
        const response = await apiRequests(GET_GROUPS);
        return response;
    } catch( $er ){
        console.warn('Las siguientes fallas son: ' , $er );
        return null;
    }
}

export const getSkills = async() => {
    try {
        const response = await apiRequests(GET_SKILLS);
        //console.log(response.data.getAllSkills);
        return response.data.getAllSkills;
    }catch( er ){
        console.warn('Las siguientes fallas son: ' , er);
        return null;
    }
}

export const getCity = async() => {
    try {
        const response = await apiRequests(GET_CITY);
        return response.data.getAllCities;
    }catch(er){
        console.warn('Las siguientes fallas son: ' , er);
        return null;
    }
}

export const getActivity = async() => {
    try {
        const response = await apiRequests(GET_ACTIVITY);
        return response.data.getActivity; 
    } catch (er) {
        console.warn('Las siguientes fallas son: ' , er );
        return null;
    }
}

// mutations 
export const createGroups = async(variables) => {
    
    try {
        //console.log(variables);
        const response = await apiRequests(CREATE_GROUP,variables)
        return response;
    }catch( er ){
        console.warn('Las sigguientes fallas son: ' , er);
        return null;
    }
}


export const createSkill = async(variables) => {
    try {
        const response = await apiRequests(CREATE_SKILLS,variables);
        return response;
    }catch ( er ){
        console.warn('Las siguientes fallas son: ' , er);
        return null;
    }
}

export const getGroupsId = async(variables) => {
    try {
        //console.log('345', variables);
        const response = await apiRequests(GET_ID_GROUPS,variables);
        return response;
    } catch (er){
        console.warn('Las siguientes fallas son: ' , er);
        return null;
    }
}

export const updateGroups = async(variables) => {
    try {
        //console.log(variables);
        const response = await apiRequests(UPDATE_GROUP,variables);
        //console.log('5678',response);
        return response;
    } catch (er){
        console.warn('errores de la siguiente', er);
        return null;
    }
}

export const updateSkill = async(variables) => {
    try {
        //console.log('578', variables);
        const response = await apiRequests(UPDATE_SKILLS,variables);
        //console.log('response', response);
        return response;
    } catch (err) {
        console.log('se presentaron los siguientes problemas' , err);
        return null;
    }
}

export const deleteSkills = async(variables) => {
    try {
        console.log(variables);
        const response = await apiRequests(DELETE_SKILLS,variables);
        console.log('response', response);
        return response.data.deleteSkill.message;
    } catch (er) {
        console.warn('Las siguientes fallas son: ' , er);
        return null;
    }
}